import { PropsWithChildren } from 'react'

import { PlatformLink } from 'components/PlatformLink'

type Props = {
  href: string
  messageId: string
}

export const Link = ({
  href,
  messageId,
  children,
}: PropsWithChildren<Props>) => (
  <PlatformLink
    className="kui-link"
    url={href}
    appSourceType="kaila_inline_link"
    trackingName="kai_conversation_output_clicked"
    trackingProps={{
      messageId,
      source: 'inline_link',
      type: 'references',
    }}
  >
    {children}
  </PlatformLink>
)
